import { StyleSheet } from 'react-native';
export function useStyle({ name = '', customStyle = {}, closeIconPosition, }) {
    const { indicatorTop } = customStyle;
    const closePositionMap = {
        'top-left': {
            top: 22,
            left: 10,
        },
        'top-right': {
            top: 22,
            right: 10,
        },
        'bottom-left': {
            bottom: 10,
            left: 10,
        },
        'bottom-right': {
            bottom: 10,
            right: 10,
        },
    };
    return {
        style: StyleSheet.create({
            closeIconStyle: Object.assign({ position: 'absolute', height: 32, zIndex: 1 }, closePositionMap[closeIconPosition]),
            indexStyle: {
                position: 'absolute',
                top: indicatorTop || 32,
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'row',
            },
            indexFontStyle: {
                fontSize: 18,
                fontWeight: 'bold',
                color: '#fff',
            },
            imageWrapperStyle: {},
            imageItemStyle: {
                width: '100%',
                height: '100%',
                resizeMode: 'contain',
            },
        }),
    };
}
